import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-combobox',
  templateUrl: './combobox.component.html',
  styleUrls: ['./combobox.component.css']
})
export class ComboboxComponent {

 @Input() e: any;
  @Input() entryData!: string;
  @Output() valueChange = new EventEmitter<string>(); 
  @Input() readonly:any;
  @Input() checkExpression:any;
  @Input() id: any;

  // onUserInput(event: any,e:any) {
  //   let selectBox = document.getElementById(e.code + "_select") as HTMLSelectElement;
  //   if (selectBox) {
  //     selectBox.value = "";  
  //   }   
  //   const inputValue = event.target.value.trim();   
  //   this.valueChange.emit(inputValue);
  // }

  // onSelectChange(event: any) {
  //   const selectedValue = event.target.value;
  //   this.valueChange.emit(selectedValue);
  // }

// }

  showDropdown = false;
  filteredValues: string[] = [];

  onUserInput(event: any) {
    const inputValue = event.target.value.trim();   
    this.entryData = inputValue;
    this.valueChange.emit(inputValue);

    const lowerInput = inputValue.toLowerCase();

    // Find matches
    const matches = this.e.values.filter((val: string) =>
      val.toLowerCase().includes(lowerInput)
    );

    if (matches.length > 0) {
      // Sort matched values
      this.filteredValues = matches.sort((a: string, b: string) => {
        return a.toLowerCase().indexOf(lowerInput) - b.toLowerCase().indexOf(lowerInput);
      });
      this.showDropdown = true;
    }
    else {
      this.filteredValues = [];
      this.showDropdown = true; // Do NOT open dropdown
    }
  }

  toggleDropdown() {
    // Show full list
    this.filteredValues = [...this.e.values];
    this.showDropdown = !this.showDropdown;
  }

  selectItem(value: string) {
    this.entryData = value;
    this.valueChange.emit(value);
    this.showDropdown = false;
  }

  hideDropdownDelayed() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 150);
}
}


